<template>
    <div class="register-step-2">
        <form action="#"
              @submit.prevent="submitForm"
              class="form"
              ref="form"
        >

            <div class="margin-top-20 margin-bottom-20" v-if="registerStepErrors.has('internalError')">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-left text-danger">
                            There was an error processing your information. Please try again later.
                        </div>
                    </div>
                </div>
            </div>

            <div class="payment-wrapper" ref="paymentInformation">
                <div class="margin-top-20 margin-bottom-20">
                    <PaymentInformation ref="paymentInformationComponent"
                                        :user-data="formData.paymentInformation"
                                        :stripe-key="stripeKey"
                                        :errors="registerStepErrors"
                                        :edit-mode="paymentInformationEditMode"
                                        @toggleEditMode="paymentInformationEditMode = !paymentInformationEditMode"
                                        @setPaymentFormState="setPaymentFormState"
                                        @componentLoading="componentLoading"
                    >
                        <div slot="title" class="row">
                            <div class="col-sm-12">
                                <h3 class="text-left text-normal label">
                                    Payment Information <i>(optional)</i>
                                </h3>
                            </div>
                            <div class="col-sm-12"  v-if="registerStepErrors.has('stripeErrors')">
                                <div class="invalid-feedback-red">
                                    {{registerStepErrors.get('stripeErrors')}}
                                </div>
                            </div>
                        </div>
                    </PaymentInformation>
                </div>
            </div>

            <div class="address-wrapper margin-top-20" ref="BillingAddress" v-if="role == 'organizer'">
                <div class="row">
                    <div class="col-sm-12">
                        <h3 class="text-left text-normal label">
                            Billing Address
                        </h3>
                    </div>
                </div>
                <div class="margin-top-20 margin-bottom-20">
                    <Address ref="billingAddressComponent"
                             :user-data="mappedBillingAddressData"
                             :static-data="staticData"
                             :edit-mode="true"
                             :errors="billingAddressErrors"
                             @componentLoading="componentLoading"
                    />
                </div>
            </div>

		<div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20">
					<div class="form-group col-sm-6">
						<button type="button" v-on:click="backAction"
						        class="btn hh-btn back-btn" name="Cancel">
							Cancel
						</button>
					</div>
					<div class="form-group col-sm-6">
						<button type="submit" :disabled="!formReady"
						        class="btn save-btn hh-btn-green" name="Save and continue">
							Save and continue
						</button>
					</div>
				</div>
        </form>


    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PaymentInformation from '../../../components/form/PaymentInformation'
  import Address from '../../../components/form/Address'
  import Form from '../../../plugins/Form'
  import { scrollTo } from '../../../utils/componentHelper'

  export default {
    name: 'Step-2',

    components: {
      PaymentInformation,
      Address,
    },

    props: {
      userData: {
        billingAddress: {
          billing_first_name: String,
          billing_last_name: String,
          billing_address_1: String,
          billing_address_2: String,
          billing_country: String,
          billing_city: String,
          billing_state: String,
          billing_zip: String,
        },
        paymentInformation: {
          name: String,
          last4: String,
          brand: String,
        },
      },
      staticData: Object,
      config: Object,
      userRoles: Array,
    },

    data: () => {
      return {
        isPaymentFormReady: true,
        paymentInformationEditMode: true,
        stripeError: null,
        loading: true,
        componentsLoadingStatus: {
          PaymentInformation: true,
        },
        formData: {
          paymentInformation: {
            name: null,
            token: null,
            last4: null,
            brand: null,
          },
          billingAddress: {
            billing_first_name: null,
            billing_last_name: null,
            billing_address_1: null,
            billing_address_2: null,
            billing_country: 'United States',
            billing_state: null,
            billing_city: null,
            billing_zip: null,
          },
          opType: 'update',
          step: 2,
        },
      }
    },

    beforeMount () {
        if (!_.isEmpty(this.userData.paymentInformation)) {
          this.formData.paymentInformation = { ...this.formData.paymentInformation, ...this.userData.paymentInformation }
        }

	    if (!_.isEmpty(this.userData.billingAddress)) {
		    this.formData.billingAddress =  { ...this.formData.billingAddress, ...this.userData.billingAddress }
	    }

        if (!_.isEmpty(this.formData.paymentInformation.last4)) {
          this.paymentInformationEditMode = false
        }
    },

    mounted () {
      this.loading = false
    },

    methods: {
      submitForm () {
        this.loading = true
        if (!this.$refs.paymentInformationComponent.shouldSubmit()) {
          this.processAddressData()
          this.sendFormData()

          return true
        }

        if (!this.$refs.paymentInformationComponent.canSubmit()) {
          scrollTo(this.$refs['form'])
          this.loading = false
          return false
        }

        this.$refs.paymentInformationComponent.submitForm().then(() => {
          if (!this.checkPaymentInformation()) {
            this.loading = false
            return false
          }

          this.processAddressData()
          this.sendFormData()

          return true
        })
      },

      processAddressData () {
        this.fillBillingAddressData(this.mappedBillingAddressData)
      },

         sendFormData () {
        this.$store.dispatch('registerStep', this.formData).then(() => {
          if (this.registerStepStatus === 'success' && this.role == 'donor') {
            this.$store.commit('setAlert', {
              message: 'Congratulations, you have successfully registered!',
              type: 'bg-success'
            })
            
            window.fbq('trackCustom', 'Registration', {type: 'donor'});
            gtag('event', 'create_an_account__donor_', {'event_category': 'Registration', 'event_label': 'Signup', 'value': 0, 'send_to': ['G-XYNG531DN3', 'G-QMLYKDX5HS']});
            
            this.$store.dispatch('fetchAuthUser').then(() => {
              this.$store.dispatch('profile/fetchData').then(() => {
                this.loading = false

                let intendedCampaignUrl = localStorage.getItem('intendedCampaignUrl')
                if (!_.isEmpty(intendedCampaignUrl)) {
                  localStorage.removeItem('intendedCampaignUrl')
                  window.location = intendedCampaignUrl
                } else {
                  this.$router.push({ name: 'profile' })
                }
              })
            })
          } else if (this.role == 'organizer') {
            this.$emit('formSubmitted')  
          } else if(this.registerStepStatus !== 'success'){
            this.loading = false
            scrollTo(this.$refs['form'])
          }
        })
      },

      checkPaymentInformation () {
        if (!_.isEmpty(this.$refs.paymentInformationComponent.$data.stripeError)) {
          this.stripeError = this.$refs.paymentInformationComponent.$data.stripeError

          scrollTo(this.$refs['form'])
          return false
        }

        return true
      },

      backAction () {
        this.$emit('navigateBack')
      },

      setPaymentFormState (value) {
        this.isPaymentFormReady = value
      },

      mapAddressData (data, prefix) {
        return {
          'firstName': data[`${prefix}_first_name`],
          'lastName': data[`${prefix}_last_name`],
          'address1': data[`${prefix}_address_1`],
          'address2': data[`${prefix}_address_2`],
          'country': data[`${prefix}_country`],
          'city': data[`${prefix}_city`],
          'state': data[`${prefix}_state`],
          'zip': data[`${prefix}_zip`],
        }
      },

      fillBillingAddressData (data) {
        this.formData.billingAddress = {
          billing_first_name: data.firstName,
          billing_last_name: data.lastName,
          billing_address_1: data.address1,
          billing_address_2: data.address2,
          billing_country: data.country,
          billing_city: data.city,
          billing_state: data.state,
          billing_zip: data.zip,
        }
      },

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },
    },

    computed: {
      registerStepStatus: {
        get () {
          return this.$store.getters['registerStepStatus'](this.formData.step)
        },
      },
      	role() {
				if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
					return 'organizer'
				}

				return 'donor'
			},

      registerStepErrors: {
        get () {
          return this.$store.getters['registerStepErrors'](this.formData.step)
        },
      },

      stripeKey () {
        if (_.isEmpty(this.config.stripe_key)) {
          return null
        }

        return this.config.stripe_key
      },

      billingAddressErrors () {
        let errorObject = new Form({}).errors

        if (!this.registerStepErrors.any()) {
          return errorObject
        }

        let billingErrors = this.mapAddressData(this.registerStepErrors.errors, 'billing')
        errorObject.record(billingErrors)
        return errorObject
      },


      hasErrors () {
        return this.registerStepStatus === 'failed'
      },

      formReady () {
        return this.isPaymentFormReady && !this.loading
      },

      mappedBillingAddressData () {
        return this.mapAddressData(this.formData.billingAddress, 'billing')
      },

      isLoading () {
        for (let component in this.componentsLoadingStatus) {
          if (this.componentsLoadingStatus[component]) {
            return true
          }
        }

        return this.loading
      },
    },

    watch: {
      isLoading (to, from) {
          this.$emit('componentLoading', 'stepComponent', to)
        }
    }
  }
</script>

<style lang="scss" scoped>
  h3.label {
    font-family: Circular Std;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 33px;
    letter-spacing: -0.01em;
    color: #000000;
    padding: 0 !important;
  }

     @media screen and (max-width: 767px) {
     h3 {
       font-size: 21px !important;
     }
    
  }
</style>
